      function SpaceItemInfo() {
  return;
}
export default SpaceItemInfo;
